import AppsIcon from '@mui/icons-material/Apps';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ClusterIcon from '@mui/icons-material/GridView';
import InsightsIcon from '@mui/icons-material/Insights';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SegmentIcon from '@mui/icons-material/Segment';
import SourceIcon from '@mui/icons-material/Source';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  OutlinedInput,
  Toolbar,
} from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import React, { useContext, useEffect, useState } from 'react';
import { MdEmail, MdTransform } from 'react-icons/md';
import { WorkflowContext } from '../../contexts/WorkflowProvider';
import './flowbuilderpannel.css';
import {
  DATA_QUALITY_AGENT,
  DEDUPLICATION_AGENT,
  DATA_QUALITY_RULES,
  DATA_QUALITY_RULES2,
  LLM_DQ_RULES,
  LLM_DQ_RULES_2,
  FETCH_SCHEMA,
  LLM_MAPPER,
  PE_DATA_REPORT,
  PE_INSIGHTS_MAPPER,
  DATA_QUALITY_REPORT,
  LLM_MAPPER_V2,
} from '../../utils/NodeModalContants';

const drawerWidth = 262;

const openedMixin = (theme) => ({
  position: 'relative',
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  background: '#111111',
  borderRadius: '5px',
});

const closedMixin = (theme) => ({
  position: 'relative',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  background: '#111111',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const menuList = [
  { id: 1, text: 'All', icon: <LibraryAddCheckIcon fontSize="small" /> },
  { id: 2, text: 'Read', icon: <TextSnippetIcon fontSize="small" /> },
  { id: 3, text: 'Data Transform', icon: <AutorenewIcon fontSize="small" /> },
  { id: 4, text: 'Data Quality', icon: <SourceIcon fontSize="small" /> },
  { id: 5, text: 'Segment', icon: <SegmentIcon /> },
  { id: 6, text: 'Insight', icon: <InsightsIcon /> },
  { id: 7, text: 'Write', icon: <DriveFileRenameOutlineIcon fontSize="small" /> },
  { id: 8, text: 'Transform', icon: <MdTransform /> },
  { id: 9, text: 'Model', icon: <PsychologyIcon fontSize="small" /> },
  { id: 10, text: 'Notification', icon: <MdEmail /> },
  { id: 11, text: 'Others', icon: <AppsIcon fontSize="small" /> },
  // { id: 13, text: 'Copy', icon: <ContentCopyIcon fontSize="small" /> },
];

export const nodeConfigs = {
  Read: [
    { key: 'ReadApi', label: 'Read Api' },
    { key: 'ReadAuroraDB', label: 'Read AuroraDB' },
    { key: 'ReadCosmos', label: 'Read Cosmos' },
    // { key: 'ReadCSV', label: 'Read CSV' },
    // { key: 'ReadCSVData', label: 'Read CSV Data' },
    { key: 'ReadCSVAws', label: 'Read CSV AWS' },
    { key: 'ReadCSVAzure', label: 'Read CSV Azure' },
    { key: 'ReadPostgres2', label: 'Read Postgres2' },
    { key: 'ReadSQLServer', label: 'Read SQLServer' },
    { key: 'ReadSnowflake2', label: 'Read SnowFlake 2' },
    { key: 'ReadOracleDB', label: 'Read OracleDB' },
    { key: 'ReadDB2', label: 'Read DB2' },
    { key: 'ReadDelimited', label: 'Read Delimited' },
    { key: 'ReadMySql', label: 'Read MySql' },
    { key: 'ReadOracle', label: 'Read Oracle' },
    { key: 'ReadPostgres', label: 'Read Postgres' },
    { key: 'ReadPublishedData', label: 'Read Published Data' },
    { key: 'Read Real-Time', label: 'Read Real-Time' },
    { key: 'ReadSnowflake', label: 'Read SnowFlake' },
  ],
  'Data Transform': [
    { key: 'AddColumn', label: 'Add Column' },
    { key: 'DeleteColumn', label: 'Delete Column' },
    { key: 'SwapColumn', label: 'Swap Column' },
    { key: 'CountBlock', label: 'Count Block' },
    { key: 'DuplicacyCheck', label: 'Duplicacy Check' },
    { key: 'Aggregation', label: 'Aggregation' },
    { key: 'StatisticalAggregation', label: 'Statistical Aggregation' },
    { key: 'Analysis', label: 'Analysis' },
    { key: 'AutomaticRuleGenerator', label: 'Automatic Rule Generator' },
    { key: 'Coalesce', label: 'Coalesce' },
    { key: 'Customer Segmentation', label: 'Customer Segmentation' },
    { key: 'Data Cleaning & Validation', label: 'Data Cleaning & Validation' },
    { key: 'Execute SQL', label: 'Execute SQL' },
    { key: 'Fuzzy Match', label: 'Fuzzy Match' },
    { key: 'Filter', label: 'Filter' },
    { key: 'FlatUnion', label: 'FlatUnion' },
    { key: 'Join', label: 'Join' },
    { key: 'KPI', label: 'KPI' },
    { key: LLM_MAPPER.nodeModalTitle, label: LLM_MAPPER.nodeModalTitle },
    { key: LLM_MAPPER_V2.nodeModalTitle, label: LLM_MAPPER_V2.nodeModalTitle },
    { key: 'Match & Merge', label: 'Match & Merge' },
    { key: 'PdfDataExtractor', label: 'Pdf Data Extractor' },
    { key: PE_INSIGHTS_MAPPER.nodeModalTitle, label: PE_INSIGHTS_MAPPER.nodeModalTitle },
    { key: 'RFM', label: 'RFM' },
    { key: 'Rules Selector', label: 'Rules Selector' },
    { key: 'Sort', label: 'Sort' },
    { key: 'Union', label: 'Union' },
    { key: 'abs', label: 'Absolute' },
    { key: 'concat_ws', label: 'Concat' },
    { key: 'coalesce', label: 'First Non-Empty' },
    { key: 'lower', label: 'lowercase' },
    { key: 'upper', label: 'UPPERCASE' },
    { key: 'floor', label: 'Floor' },
    { key: 'current_date', label: 'Current Date' },
    { key: 'current_time', label: 'Current Time' },
    { key: 'trim', label: 'Trim Spaces' },
    { key: 'initcap', label: 'Capitalize Words' },
    { key: 'isnumber', label: 'Is Number?' },
    { key: 'instr', label: 'Find Position' },
    { key: 'isnull', label: 'Is Empty?' },
    { key: 'length', label: 'Length' },
    { key: 'indexof', label: 'Find Index' },
    { key: 'ltrim', label: 'Trim Left' },
    { key: 'lpad', label: 'Pad Left' },
    { key: 'isspaces', label: 'Only Spaces?' },
    { key: 'rpad', label: 'Pad Right' },
    { key: 'replace', label: 'Replace Text' },
    { key: 'substr', label: 'Substring' },
    { key: 'split', label: 'Split' },
    { key: 'regexp_replace', label: 'Regex Replace' },
    { key: 'round', label: 'Round Off' },
    { key: 'regexp_instr', label: 'Regex Position' },
    { key: 'to_decimal', label: 'To Decimal' },
    { key: 'to_float', label: 'To Float' },
    { key: 'to_integer', label: 'To Integer' },
    { key: 'to_bigint', label: 'To BigInt' },
    { key: 'row_number', label: 'Row Number' },
    { key: 'mod', label: 'Mod' },
    { key: 'power', label: 'Power Of' },
    { key: 'reverse', label: 'Reverse Text' },
    { key: 'trunc_dates', label: 'Trim Date' },
    { key: 'nullif', label: 'Make Empty If Match' },
    { key: 'regexp_substr', label: 'Regex Substring' },
    { key: 'last_day', label: 'End of Month' },
    { key: 'add_to_date', label: 'Add to Date' },
    { key: 'date_diff', label: 'Date Difference' },
    { key: 'to_date', label: 'To Date' },
    { key: 'add_static_value', label: 'Add Static Value' },
    { key: 'rtrim', label: 'Trim Right' },
    { key: 'to_char_numbers', label: 'Number to Text' },
    { key: 'to_char', label: 'Format Date' },
    { key: 'is_date', label: 'Is Date?' },
    { key: 'date_compare', label: 'Compare Dates' },
    { key: 'reg_match', label: 'Regex Match?' },
    { key: 'reg_extract', label: 'Regex Extract' },
    { key: 'ceil', label: 'Ceil' },
    { key: 'trunc_numbers', label: 'Trim Number' },
  ],
  Transform: [
    { key: 'Datatype Conversion', label: 'Datatype Conversion' },
    { key: 'Date Time Feature', label: 'Date Time Feature' },
    { key: 'Drop', label: 'Drop' },
    { key: 'Handle Null', label: 'Handle Null' },
    { key: 'Imbalanced Data', label: 'Imbalanced Data' },
    { key: 'Imbalanced Data Sampling', label: 'Imbalanced Data Sampling' },
    { key: 'Label Encoder', label: 'Label Encoder' },
    { key: 'Math Transformation', label: 'Math Transformation' },
    { key: 'OneHot Encoder', label: 'OneHot Encoder' },
    { key: 'Outlier', label: 'Outlier' },
    { key: 'Resample', label: 'Resample' },
    { key: 'Scaler', label: 'Scaler' },
  ],
  Model: [
    { key: 'Prediction', label: 'Prediction' },
    { key: 'Training', label: 'Training' },
  ],
  'Data Quality': [
    { key: 'Dedupe', label: 'Dedupe' },
    // { key: 'DataQualityIssues', label: 'Data Quality Issues' },
    { key: 'DataQualityIssues2', label: 'Data Quality Issues' },
    { key: LLM_DQ_RULES_2.nodeModalTitle, label: LLM_DQ_RULES_2.nodeModalTitle },
    { key: DATA_QUALITY_RULES.nodeModalTitle, label: DATA_QUALITY_RULES.nodeModalTitle },
    { key: DATA_QUALITY_RULES2.nodeModalTitle, label: DATA_QUALITY_RULES2.nodeModalTitle },
    // { key: DATA_QUALITY_AGENT.nodeModalTitle, label: DATA_QUALITY_AGENT.nodeModalTitle },
    { key: DEDUPLICATION_AGENT.nodeModalTitle, label: DEDUPLICATION_AGENT.nodeModalTitle },
    { key: DATA_QUALITY_REPORT.nodeModalTitle, label: DATA_QUALITY_REPORT.nodeModalTitle },
    { key: 'DataProfiling', label: 'Data Profiling' },
    { key: 'DataValidation', label: 'Validation' },
    { key: 'Source', label: 'Source' },
    { key: LLM_DQ_RULES.nodeModalTitle, label: LLM_DQ_RULES.nodeModalTitle },
  ],
  Notification: [{ key: 'Email', label: 'Email' }],
  Insight: [
    { key: PE_DATA_REPORT.nodeModalTitle, label: PE_DATA_REPORT.nodeModalTitle },
    { key: 'Plot', label: 'Plot' },
    { key: 'Visualization', label: 'Visualization' },
    { key: 'VisualInsights', label: 'Visual Insights' },
  ],
  Segment: [{ key: 'Segment', label: 'Segmentation' }],
  Others: [
    { key: 'FileUploader', label: 'File Uploader' },
    { key: FETCH_SCHEMA.nodeModalTitle, label: FETCH_SCHEMA.nodeModalTitle },
    { key: 'C360', label: 'Predictive Analytics' },
    { key: 'Data Cleansing', label: 'Data Cleansing' },
    { key: 'Udf', label: 'Udf' },
  ],
  Write: [
    { key: 'Ingestion Write', label: 'Ingestion Write' },
    { key: 'OpenSearch', label: 'Open Search' },
    { key: 'Postgres', label: 'Write Postgres' },
    { key: 'SnowFlake', label: 'SnowFlake' },
    { key: 'Write', label: 'Write' },
    { key: 'WriteAzure', label: 'Write Azure' },
    { key: 'WriteCsvAWS', label: 'Write AWS' },
    { key: 'WritePostgres', label: 'Write Postgres' },
    { key: 'WriteSqlServer', label: 'Write SqlServer' },
    { key: 'WriteOracleDB', label: 'Write OracleDB' },
    { key: 'WriteSnowflake', label: 'Write Snowflake' },
  ],
  Union: [
    { key: 'Aggregation', label: 'Aggregation' },
    { key: 'Coalesce', label: 'Coalesce' },
    { key: 'Data Cleaning & Validation', label: 'Data Cleaning & Validation' },
    { key: 'Fuzzy Match', label: 'Fuzzy Match' },
    { key: 'FlatUnion', label: 'FlatUnion' },
    { key: 'Match & Merge', label: 'Match & Merge' },
    { key: 'Open Search', label: 'Open Search' },
    { key: 'Union', label: 'Union' },
  ],
};

export default () => {
  const onDragStart = (event, nodeType, nodeValue, className) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.setData('nodeName', nodeValue);
    event.dataTransfer.setData('className', className);
    event.dataTransfer.effectAllowed = 'move';
  };

  const [open, setOpen] = useState(false);
  const [type, setType] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleList = (event, type) => {
    setType(type);
  };

  const renderNodes = () => {
    const filterNodes = (nodes) =>
      nodes
        .filter(({ label }) => label.toLowerCase().includes(searchTerm.toLowerCase())) // Filter based on searchTerm
        .sort((a, b) => a.label.localeCompare(b.label))
        .map(({ key, label }) => renderNode(key, label));

    if (type === 'All') {
      const allNodes = Object.values(nodeConfigs)
        .flat()
        .reduce((acc, node) => {
          if (!acc.some((item) => item.key === node.key)) {
            acc.push(node);
          }
          return acc;
        }, []);
      return filterNodes(allNodes);
    }

    return nodeConfigs[type] ? filterNodes(nodeConfigs[type]) : null;
  };

  const renderNode = (key, label) => (
    <div
      key={key}
      className="dndnode input"
      onDragStart={(event) => onDragStart(event, 'editableNode', key, 'dndnode input')}
      draggable
    >
      <div className="node-container">{label}</div>
    </div>
  );

  return (
    <>
      <Box
        className="custom-scrollbar"
        sx={{ display: 'flex', justifyContent: 'space-between', minHeight: 0, height: '60vh' }}
      >
        <AppBar
          position="absolute"
          open={open}
          sx={{
            background: '#111111',
            width: '14px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '12vh',
            borderTopRightRadius: '12px',
            borderBottomRightRadius: '12px',
            left: open ? '-3.8px' : '57px',
            top: `calc(100% - 36vh)`,
          }}
        >
          <Toolbar>
            <IconButton color="inherit" size="small" aria-label="open drawer" onClick={handleDrawerOpen}>
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Box
            className="custom-scrollbar"
            sx={{
              display: 'flex',
              height: '100%',
              background: '#111111',
              borderRadius: '5px',
            }}
          >
            <List>
              {menuList.map((item) => (
                <ListItem key={item.id} disablePadding sx={{ display: 'flex', my: '3px' }}>
                  <ListItemButton
                    sx={{
                      minHeight: 30,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      whiteSpace: 'break-spaces',
                      textAlign: 'center',
                      '&.Mui-selected': {
                        background: '#4a4e69',
                        height: '65px',
                        width: '80px',
                        maxWidth: '95px',
                        borderRadius: '3px',
                        '&:hover': { backgroundColor: '#4a4e69' },
                        '.MuiListItemIcon-root, .MuiListItemText-root': {
                          color: '#fff',
                        },
                      },
                    }}
                    selected={type === item.text}
                    onClick={(event) => handleList(event, item.text)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 0.5 : 'auto',
                        color: '#696969',
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      sx={{ opacity: open ? 1 : 0, color: '#696969' }}
                      primaryTypographyProps={{
                        fontSize: 12,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                height: '78vh',
                display: 'flex',
                flexWrap: 'wrap',
                overflowY: 'auto',
                alignContent: 'flex-start',
                py: 1,
                minWidth: '200px',
              }}
            >
              <FormControl
                sx={{ margin: '3px', width: '80%', border: '1px solid grey', borderRadius: '5px' }}
                variant="outlined"
              >
                <OutlinedInput
                  id="nodesSectionSearch"
                  sx={{
                    color: '#fff',
                    height: '30px',
                    padding: '0 5px 0 0',
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <SearchIcon sx={{ color: 'grey' }} />
                    </InputAdornment>
                  }
                  placeholder="Search"
                  autoComplete="off"
                  value={searchTerm} // Add value from state
                  onChange={(e) => setSearchTerm(e.target.value)} // Update searchTerm state
                />
              </FormControl>
              {renderNodes()}
            </Box>
          </Box>
        </Drawer>
      </Box>
    </>
  );
};
